/**
 * Helpers for operating on unknown data and type-checking
 */

export interface IDictionaryLike {
  [index: string]: unknown;
}

/**
 * Check if candidate acts like an object
 * @param candidate data to check
 */
export const isDictionaryLike = (candidate: unknown): candidate is IDictionaryLike => {
  return typeof (candidate === "object") && candidate !== null;
};

/**
 * Check if candidate is an Error
 * @param candidate unknown thing to check
 */
export const isError = (candidate: unknown): candidate is Error => {
  return candidate instanceof Error;
};

/**
 * Ensures that candidate is an Error, by passing Errors through
 * or constructing an Error if not.
 *
 * Useful in catch blocks to transform the caught thing into an Error
 *
 * @param candidate unknown thing to make an Error
 */
export const ensureError = (candidate: unknown): Error => {
  if (isError(candidate)) {
    return candidate;
  } else if (typeof candidate === "string") {
    // someone threw a string, wrap in an Error
    return new Error(candidate);
  }

  // weird malformed error that isn't a string
  return new Error(`Unknown error: ${String(candidate)}`);
};
